



















import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../lib/abpbase"
import {HealthPropadandaInfo} from "../../api/healthPropaganda"

@Component({
    components: {}
})
export default class AddOrEdit extends AbpBase{
    @Prop({required: true, default: false}) value:boolean
    @Prop() id:any
    @Prop() title:any
   
    url = XMLHTTP_BASEURL
    created() {
        this.getData()
    }
    info:any = {}
    async getData(){
        let res = await HealthPropadandaInfo({id:this.id})
        console.log(res)
        this.info = res.data
    }
    cancel() {
        this.$emit('input', false)
    }

}
